export class CookieHelper {
  static setCookie(cookieName, cookieValue, expiresDays = 900) {
    let d = new Date();
    d.setTime(d.getTime() + expiresDays * 24 * 60 * 60 * 1000);
    let expires = 'expires=' + d.toUTCString();
    document.cookie = cookieName + '=' + cookieValue + ';secure;SameSite=none;' + expires + ';path=/';
  }

  static getCookie(cookieName, defaultValue = '') {
    let name = cookieName + '=';
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) === 0) {
        return c.substring(name.length, c.length);
      }
    }
    return defaultValue;
  }

  static CookieNameEnum = {
    ColorInfoBoxPl: 'colorinfoboxpl',
    PersonalLinksCollapsed: 'personallinkscollapsed',
    Theme: 'theme',
    Icons: 'icons',
  };
}

export default CookieHelper;
